<template>
    <div>
      <b-row class="align-items-center mb-3">
        <b-col cols="12" lg="6">
          <h6 class="cal-label">What College or University might you attend?</h6>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="cal-card">
            
            <b-form-group class="mb-0" label-for="collage-autocomplete">
            <b-textarea v-model="collegeName"   
                                              @input="onInput"
                                              @focus="showSuggestions = true"
                                              @blur="hideSuggestions" class="mb-0 text-center big-input-font" placeholder="Enter college or university"></b-textarea>
                                              
                  <ul
                    v-if="showSuggestions && suggestions.length"
                    class="list-group position-absolute w-100"
                    style="z-index: 1000; max-height: 200px; overflow-y: auto;"
                  >
                    <li
                      v-for="zip_1 in suggestions"
                      :key="zip_1.collage_name"
                      class="list-group-item list-group-item-action"
                      @mousedown.prevent="selectName(zip_1)"
                    >
                      {{ zip_1.college_name }}
                    </li>
                  </ul>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-row class="align-items-center mb-3">
        <b-col cols="12" lg="6">
          <h6 class="cal-label">Would you be considered In-State or Out-of-State?</h6>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="cal-card text-center">
            <b-button-group class="mb-0 parent-selection">
              <b-button class="" :pressed="isInState" @click="setState(true)">In-State</b-button>
              <b-button class="" :pressed="!isInState" @click="setState(false)">Out-of-State</b-button>
            </b-button-group>
          </div>
        </b-col>
      </b-row>
      
      <b-row class="align-items-center mb-3">
        <b-col cols="12" lg="6">
          
           <div class="d-flex align-items-center">
              <h6 class="cal-label">
                Estimated Total Cost of Attendance
              </h6>
              <div class="hover-info-box">
                <span class="hover-icon ml-2">
                  <i class="far fa-question-circle"></i>
                </span>
                <div class="hover-info position-right">
                  <h5 class="hover-info-title fw-700">
                      "This is the full estimated cost for all years
                      needed to complete a typical degree at the
                      selected school. It includes tuition, housing,
                      meals, books, fees, and other expenses - not
                      just tuition".
                  </h5>
                </div>
              </div>
            </div>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="cal-card text-center">
            {{ selectedCollege && (isInState ? `$${selectedCollege.in_state}` : `$${selectedCollege.out_of_state}`) }}
          </div>
        </b-col>
      </b-row>
      <b-row class="align-items-center mb-3">
        <b-col cols="12" lg="6">
          <h6 class="cal-label">
            What % assistance will you receive toward the full cost of attendance?
          </h6>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="cal-card">
            <b-row class="align-items-center justify-content-between">
              <b-col cols="8">
                <vue-slider v-model="assistance" :min="0" :max="100"></vue-slider>
              </b-col>
              <b-col cols="4">
                <b-input-group size="xs" append="%">
                  <b-form-input type="number" v-model="assistance"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="align-items-center mb-3">
        <b-col cols="12" lg="6">
          <h6 class="cal-label">
            What % will you cover yourself using personal savings or by working during attendance?
          </h6>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="cal-card">
            <b-row class="align-items-center justify-content-between">
              <b-col cols="8">
                <vue-slider v-model="selfCover" :min="0" :max="100"></vue-slider>
              </b-col>
              <b-col cols="4">
                <b-input-group size="xs" append="%">
                  <b-form-input type="number" v-model="selfCover"></b-form-input>
                </b-input-group>
                <!-- <h6 class="d-inline-block font-weight-bold mb-0 text-end">
                  <input >{{ selfCover }}
                  %</h6> -->
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="align-items-center mb-3">
        <b-col cols="12" lg="6">
          <h6 class="cal-label">
            The estimated monthly student loan payment amount is approximately
          </h6>
        </b-col>
        <b-col cols="12" lg="6">
          <div class="cal-card text-center">
            <b-row>
              <b-col cols="12">
                <h4 class="d-inline-block font-weight-bold text-center">$ {{ estimatedPayment }}</h4>
              </b-col>
              <b-col cols="12">
                <b-button class="btn-green mt-3" @click="getLoanRes" v-if="!loading">Calculate</b-button>
                <b-button variant="success" disabled class="mt-3" v-else>Calculating ...</b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="align-items-center mb-3">
        <b-col cols="12" lg="12">
          <p class="mt-3 small text-muted">
            <strong>Note :</strong> 
            This is a simplified estimate. Actual loan payments may vary based on the specific loan terms,
            interest
            rates at the time of borrowing, and any changes in repayment plans. For a more accurate calculation tailored
            to
            your situation, consider using the <a target="_blank" href="https://studentaid.gov/loan-simulator/">Federal Student Aid Loan Simulator</a>.
          </p>
        </b-col>
      </b-row>
      <b-row class="align-items-center mb-3 text-center border-top">
        <b-col cols="12" lg="12">
          <b-button class="btn btn-green mt-3" @click="saveEstimate">Save</b-button>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import { trim } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import universities from "@/data/universities.json";

export default {
  components: {
    VueSlider
  },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      collegeName: '',
      selectedCollege: null,
      isInState: false,
      assistance: 20,
      selfCover: 20,
      estimatedPayment: 0,
      loading: false,
      suggestions: [],
      selectedZip: null,
      showSuggestions: false,
      debounceTimeout: null,
    };
  },
  watch:{
    selfCover(){
      this.estimatedPayment = 0
    },
    assistance(){
      this.estimatedPayment = 0
    },
    isInState(){
      this.estimatedPayment = 0
    },
  },
  methods: {
    selectName(name){
      this.selectedCollege = name;
      this.collegeName = name.college_name;
      this.showSuggestions = false;
      this.estimatedPayment = 0
    },
    onInput() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.showSuggestions = true;
        this.fetchNames();
      }, 300); // debounce delay
    },
    fetchNames(){
      if (this.collegeName.length < 2) {
        this.suggestions = [];
        return;
      }

      try {
        console.log(universities);
        
        this.suggestions = universities.filter((item)=>item.college_name.toLowerCase().includes(this.collegeName.toLowerCase())); // Assuming your API returns an array of { id, zip, city, state }
      } catch (err) {
        console.error('Failed to fetch zips:', err);
        this.suggestions = [];
      }
    },
    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200); // Delay to allow mousedown event
    },
    setState(state) {
      this.isInState = state;
    },
    closeModal() {
      this.$emit('close');
    },
    saveEstimate() {
      this.$emit('save', { collegeName: this.collegeName, estimatedPayment: this.estimatedPayment });
      // this.closeModal();
    },
    /**
     * Calculates % of a given value.
     * 
     * @param {number} value - The number to take 30% of
     * @returns {number} - 30% of the input value
     */
    calculatePercent(value,percent) {
      return value * percent;
    },

    /**
     * Calculates the payment for a loan based on constant payments and interest rate.
     * 
     * @param {number} rate - Interest rate per period (e.g., monthly interest rate)
     * @param {number} nper - Total number of payment periods
     * @param {number} pv - Present value (loan amount)
     * @returns {number} - Payment amount per period
     */
     calculateLoanPayment(rate, nper, pv) {
        if (rate === 0) return pv / nper; // No interest
        return (pv * rate) / (1 - Math.pow(1 + rate, -nper));
      },
    //  calculateLoanPayment(rate, nper, pv) {
    //   if (rate === 0) return -(pv / nper);
    //   console.log('result ==> ', -(pv * rate) / (1 - Math.pow(1 + rate, -nper)))
    //   return -(pv * rate) / (1 - Math.pow(1 + rate, -nper));
    // },
    unmaskMoneyValue(val) {
      if (typeof val === 'string') {
        return val.replace(',', '');
      } else {
        return val;
      }
    },
    async getLoanRes() {
      if (trim(this.collegeName) === '') {
        alert('Please enter the college name');
        return;
      }
      const attendance = this.unmaskMoneyValue(this.isInState ? this.selectedCollege.in_state : this.selectedCollege.out_of_state)
      const assistance = this.calculatePercent(attendance, this.assistance / 100);
      const selfCover = this.calculatePercent(attendance, this.selfCover / 100);
      const annualRate = 0.065; // 6.5%
      const monthlyRate = annualRate / 12; // Monthly interest rate
      const months = 10 * 12; // 10 years in months
      //const loanAmount = assistance + selfCover; // Amount to be financed
      const loanAmount = attendance - assistance - selfCover; // Amount to be financed
      // console.log('result -> ', attendance, assistance, selfCover, loanAmount, monthlyRate, months);
      
      this.estimatedPayment = Math.abs(this.calculateLoanPayment(monthlyRate, months, loanAmount)).toFixed(0);
      // const state = this.isInState ? 'In-State' : 'Out-of-State';
      // const prompt = `
      //           You are an AI Assistant for a college student. Your task is to estimate the monthly student loan payment amount based on the information provided by the user in JSON format.
      //           The user will provide the college name, whether they are In-State or Out-of-State, the percentage of assistance they will receive, and the percentage they will cover themselves.:  
      //           **Estimate the Monthly Student Loan Payment Amount using the following method:**  

      //           We need to estimate a potential college Student Loan Payment based on the following variables:College name = ${this.collegeName} 
      //           1 - Total Cost of Attendance per academic year for a ${state} is $${this.isInState ? this.selectedCollege.in_state : this.selectedCollege.out_of_state}
      //           2 - % scholarship and other assistance the student will receive toward the Total Cost of Attendance ${this.assistance}%
      //           3 - % the student will pay toward the Total Cost of Attendance with personal funds or working during attendance ${this.selfCover}%
      //           4 - Amount of loan to be financed = (A x B) x (1-C-D)
      //           5 - Loan Interest Rate = 6.5%
      //           6 - Loan Repayment Years = 10.
      //           7. **Return only** the predicted monthly payment amount in JSON format, with absolutely no extra text, explanations, or formatting.  
      //           8. If the university is different, adjust the cost of attendance estimate but follow the same method.  

      //           **Output Format (Strictly Follow):**  
      //           {
      //               "monthly_payment": <calculated_amount>
      //           }

      //           **Important:**  
      //           - The response must be a valid JSON object string with no additional text before or after.  
      //           - Do not include any explanations, notes, or markdown formatting.  
      //           - If calculations are needed, do them silently and only return the final JSON.  
      //           - Example of valid output: {"monthly_payment": 400}  
      //           `;


      // this.loading = true;
      // const formData = new FormData();
      // formData.append('task', 'plain');
      // formData.append('text', prompt);
      // const result = await this.$http.post('https://editor.creativebuffer.com/get_response_2/', formData);
      // // console.log();
      // try {
      //   this.estimatedPayment = JSON.parse(result.data.data) && JSON.parse(result.data.data).monthly_payment.toFixed(0) || 0;
      //   this.loading = false; 
      // } catch (error) {
      //   this.getLoanRes()
      // }

    }
  }
};
</script>

<style scoped>
.cal-label {
  font-size: 18px;
  color: #505050;
  font-weight: 500;
  line-height: 26px;
}

.cal-card {
  border: solid 1px #E3E8F5;
  background-color: #F8F8FF;
  padding: 15px;
  border-radius: 10px;
}

/* Modal content styling */
#student-loan-modal>>>.modal-body {
  padding: 1.5rem;
  font-family: "Poppins", sans-serif !important;
}


.cal-card .btn-group .btn:hover,
.cal-card .btn-group .btn:focus,
.cal-card .btn-group .btn{
  border-radius: 10px !important;
  margin: 4px;
  border-radius: 6px !important;
  background-color: #c2c2c2;
  border: solid 1px #ddd;
  color: #000;
}
.darkmode .cal-card .btn-group .btn:hover,
.darkmode .cal-card .btn-group .btn:focus,
.darkmode .cal-card .btn-group .btn{
  background-color: #151d32;
    border: solid 1px #151d32;
    color: #83919b;
}

#student-loan-modal .btn-group .btn.active{
  background-color: #4CAF50 !important;
  border-color: #4CAF50 !important;
  color: #fff;
}
.parent-selection button.active {
    background: #2ba195 !important;
    border-color: #2ba195 !important;
    color: #fff!important;
}

</style>